import Connector from './connector';
import { TransactionDetailsProps } from './TransactionDetails.proptype';
import { DetailedWithTabs } from '../DetailedWithTabs';

export * from './TransactionDetails.proptype';

export const TransactionDetails = (props: TransactionDetailsProps) => (
  <Connector {...props} component={DetailedWithTabs} />
);
